import React from 'react'
import {isLoggedIn} from "../../helpers/utils";
import BannerImageTech from "../../assets/banner.tech.png"
import BannerImageCeu from "../../assets/banner.ceu.png"
import BannerImageCourses from "../../assets/banner.courses.png"
import BannerImageLending from "../../assets/banner.lending.png"
import BannerImageRefferal from "../../assets/banner.refferral.png"
import BannerImageResource from "../../assets/banner.resource.png"
import BannerImage from "../../assets/banner.png"
import {Link} from "react-router-dom";

const bannerMap = {
  'contact us': BannerImageTech,
  'my-ceu': BannerImageCeu,
  'sign in': BannerImage,
  courses: BannerImageCourses,
  'lending-library': BannerImageLending,
  referral: BannerImageRefferal,
  resource: BannerImageResource,
  'my-lending-orders': BannerImageLending,
}
  const Banner = (props) => {
    // Determine which banner to show (fallback to default)

    const key = props.pageName?.toLowerCase() || ''
    const selectedBanner = bannerMap[key] || BannerImage

    // Wrapper class based on login state
    const wrapClass = isLoggedIn() ? 'BannerWrap BannerLayout' : 'BannerWrap'
    console.log('selectedBanner =', selectedBanner);
    console.log('props =', key);
    return (
        <>

            {/* <div className='BannerWrap BannerLayout'> */}
            {
            isLoggedIn()

            ?

               <div className={wrapClass} style={{ backgroundImage: `url('${selectedBanner}')` }}>
                <div className='HeadingWrap'>
                    <h1></h1>
                </div>
            </div>
            :

                  <div className={wrapClass} style={{ backgroundImage: `url('${selectedBanner}')` }}>
                    {/*<div className='HeadingWrap'>
                        {props.mainTitle}
                        <p className='breadcrumb'><Link to='/'>Home</Link> <i className="fa fa-chevron-right" aria-hidden="true"></i> {props.pageName}</p>
                    </div>*/}
                </div>

            }

        </>
    )
  }

Banner.defaultProps = {
    mainTitle: '',
    pageName: '',
}

  export default Banner
